<template>
  <div class="container">
    <b-row align-h="center" align-v="center" v-if="reportToUse">
      <b-col sm="auto">
        <b-dropdown id="dropdown-1" :text="filterProperty" class="m-md-2">
          <b-dropdown-item v-for="property in properties" v-model="filterProperty" @click="filterDropdown(property)">{{property}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col sm="auto">
        <b-form-input type="text" v-model="filterValue" placeholder="Filter Value">Test</b-form-input>
      </b-col>
      <b-col sm="auto">
        <i class="material-icons md-24 clickable" @click="addToFilterMap(filterProperty, filterValue)">filter_list</i>
      </b-col>
      <b-col sm="auto">
        <i class="material-icons md-24 clickable" @click="clearFilters">clear</i>
      </b-col>
    </b-row>
    <b-row align-h="center" align-v="center" v-if="reportToUse">
      <b-col>
        <div>
          <b-badge variant="secondary" class="clickable" v-for="filter in filterMap" @click="removeFilter(filter)">
            <span>{{filter.property}}: {{filter.value}}</span>
            <i class="material-icons md-24 mini-icon" @click="clearFilters">clear</i>
          </b-badge>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="center" align-v="center" v-if="reportToUse">
      <b-col sm="auto">
        <h5>Total Races: {{this.totalRaces}}</h5>
      </b-col>
      <b-col sm="auto">
        <h5>Visible: {{this.reportToUse.races.length}} ({{(this.reportToUse.races.length / this.totalRaces * 100).toFixed(0)}}%)</h5>
      </b-col>
    </b-row>
    <div v-if="reportLoading">
      <b-row  align-h="center">
        <b-spinner  variant="success" label="Spinning"></b-spinner>
      </b-row>
      <b-row v-if="reportLoading" align-h="center">
        <h6>Loading... can take up to a minute</h6>
      </b-row>
    </div>
    <b-row align-h="center">
      <b-col sm="auto" v-for="property in properties">
        <ReportSuccessByPropertyTable
          v-if="reportToUse"
          :reloadCounter="reloadCounter"
          :report="reportToUse"
          :property="property"
          v-on:filter="addToFilterMap(property, $event)"
          >Load</ReportSuccessByPropertyTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import EvaluationReport from '../models/EvaluationReport'
import ReportSuccessByPropertyTable  from './ReportSuccessByPropertyTable'
export default {
  name: 'Report',
  components: {
    ReportSuccessByPropertyTable
  },
  props: {
  },
  data () {
    return {
      title: 'Report',
      report: undefined,
      reportToUse: undefined,
      reportLoading: false,
      properties: ['location', 'isHandicap','class','classNumber','type','runners', 'raceType', 'distanceInFurlongs','experienceCategory', "predictedWinnerOdds", "isOddsOn", "betAgainstOddsOn", "shouldBet"],
      filterProperty: "Filter",
      filterValue: undefined,
      filterMap: [],
      reloadCounter: 0,
      totalRaces: 0
    }
  },
  watch: {
    $route(to, from) {
      this.loadReport()
    }
  },
  methods: {
    filterDropdown: function(property) {
      this.filterProperty = property
    },
    loadReport: function () {
      this.report = undefined
      this.reportToUse = undefined
      if (this.$route.params.datasetNumber && this.$route.params.configName) {
        this.reportLoading = true
        this.report = new EvaluationReport(this.$route.params.configName, this.$route.params.datasetNumber)
        this.report.load(this.$route.query.burstCache).then(() => {
          this.totalRaces = this.report.races.length
          this.reportToUse = this.report
          this.filter()
          this.reloadCounter++
          this.reportLoading = false
        })
      }
    },
    addToFilterMap: function (property, value) {
      if (value) {
        var valueArr = value.split(",")
        valueArr.forEach(value => {
          if (this.filterMap.filter(obj => obj.property === property && obj.value === value).length === 0) {
            this.filterMap.push({property: property, value: value})
          }
        })

      }
      this.loadReport()
    },
    filter: function () {
      if (this.filterMap.length > 0) {
        var uniqueFilterProperties = []
        this.filterMap.forEach(filterObj => {
          if (uniqueFilterProperties.indexOf(filterObj.property) === -1) uniqueFilterProperties.push(filterObj.property)
        })
        this.reportToUse.races = this.report.races.filter(race => {
          var matchCount = 0
          this.filterMap.forEach(filterObj => {
            if (race[filterObj.property] + "" === filterObj.value + "") {
              matchCount++
            }
          })
          return matchCount === uniqueFilterProperties.length
        })
        this.reloadCounter++
      }
    },
    removeFilter(filterObj) {
      this.filterMap = this.filterMap.filter(obj => obj != filterObj)
      this.loadReport()
    },
    clearFilters: function () {
      this.filterMap = []
      this.loadReport()
    }
  },
  mounted () {
    this.loadReport()
  }
}

</script>

<style>

.badge-secondary {
  margin-right: 5px
}

.mini-icon {
  font-size: 10px !important;
  text-align: center
}


</style>
